import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { PageKind, UiModeType } from 'jk-service';
import { TaxwcService, templateUrlConfigTax } from './../_service_tax';
//import { Taxpi92DetailComponent } from './taxpi92-detailPkg.component';
import { TaxwcEditComponent, } from './../_edit_tax';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-taxpi92',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    //Taxpi92DetailComponent,
    //TaxwcEditComponent,
    AdvComModule,

  ],
  templateUrl: templateUrlConfigTax.taxpi92,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Taxpi92Component extends jkSingleComponent implements OnInit {
  override _programId = 'taxpi92';
  constructor() {
    super();
    this.srv = new TaxwcService();
    this.uiMode = UiModeType.dialog;
    this.title = 'TURNKEY上傳發票結果維護';
    this.gridInitOpt = { programId: this.programId, sortField: 'WC090', sort: 'asc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = TaxwcEditComponent;


    this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */


}
